import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ja_JP from './ja-JP'
import en_US from './en-US'

// 注册插件
Vue.use(VueI18n)

// 实例化
const i18n = new VueI18n({
	locale: 'ja-JP', // 默认语言（可从本地存储/浏览器语言读取）
	fallbackLocale: 'ja-JP', // 语言不存在时的 fallback
	messages: {
		'ja-JP': ja_JP,
		'en-US': en_US
	}
})

export default i18n